export default __webpack_public_path__ + "static/media/eth-selected.d9c23066.svg";